module.exports = __webpack_public_path__ + "img/select.78f5778c.svg";